var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saveCancel pr-6 py-3"},[_c('ads-button',{staticClass:"mr-3",attrs:{"type":"reset","button-text":"Cancel","tertiary":""},on:{"click":function($event){return _vm.$emit('cancel')}}}),_c('ads-button',{attrs:{"type":"submit","button-text":"Update"},on:{"click":function($event){return _vm.$emit('submit')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }